import { BffComponentType as Component } from "~/bff/ComponentsConfig";
import { Copyright } from "~/bff/types/Copyright";
import { CountrySelector } from "~/bff/types/CountrySelector";
import { Footer } from "~/bff/types/Footer";
import { FooterNav } from "~/bff/types/FooterNav";
import { FooterNavChildren } from "~/bff/types/FooterNavChildren";
import { FooterSocialLinks } from "~/bff/types/FooterSocialLinks";

import { ConvertedFooterProps, NavItem } from "../types";

const findComponentByName = (data: Footer, name: Component) =>
  data?.children?.find(
    (child) => (child as { component: string })?.component === name,
  );

export const convertFooterToProps = (
  footer?: Footer | null,
): ConvertedFooterProps | null | undefined => {
  if (!footer) {
    return null;
  }

  const foundComponents = {
    countrySelector: findComponentByName(footer, Component.COUNTRY_SELECTOR) as
      | Partial<CountrySelector>
      | undefined
      | null,
    footerSocialLinks: findComponentByName(footer, Component.FOOTER_SOCIAL_LINKS) as
      | Partial<FooterSocialLinks>
      | undefined
      | null,
    footerNav: findComponentByName(footer, Component.FOOTER_NAV) as
      | Partial<FooterNav>
      | undefined
      | null,
    copyright: findComponentByName(footer, Component.COPYRIGHT) as
      | Partial<Copyright>
      | undefined
      | null,
  };

  return {
    countriesData: {
      countries: foundComponents.countrySelector?.children?.map(
        (child) => child?.props,
      ),
      countrySelectorHeader: {
        ...foundComponents.countrySelector?.props,
      },
    },

    socialLinks: foundComponents.footerSocialLinks?.children?.map((child) => {
      return {
        ...child?.props?.link,
        ...child?.props?.icon,
      };
    }),

    footerNav:
      foundComponents.footerNav?.children?.reduce(
        (accumulator: NavItem[], navItem) => {
          const item: NavItem = {
            headline: navItem?.props?.title ?? undefined,
            links: (navItem as FooterNavChildren)?.children?.map(
              (item) => item?.props ?? undefined,
            ),
          };

          return [...accumulator, item];
        },
        [],
      ) ?? undefined,

    copyright: foundComponents.copyright?.props?.title ?? undefined,
  };
};
